import get from './get';
import changeStatus from './changeStatus';
import store from './store';
import update from './update';
import destroy from './destroy';
import cancelNotification from './cancelNotification';
import duplicate from './duplicate';
import storeCustomShortCode from './storeCustomShortCode';
import updateCustomShortCode from './updateCustomShortCode';
import deleteCustomShortCode from './deleteCustomShortCode';
import getCustomShortCodes from './getCustomShortCodes';
import sendTestNotification from './sendTestNotification';
import exportNotifications from './exportNotifications';
import importNotifications from './importNotifications';

export default {
  get,
  changeStatus,
  store,
  update,
  destroy,
  cancelNotification,
  duplicate,
  storeCustomShortCode,
  updateCustomShortCode,
  deleteCustomShortCode,
  getCustomShortCodes,
  sendTestNotification,
  exportNotifications,
  importNotifications,
};



// WEBPACK FOOTER //
// ./src/app/services/automation/index.js